import { DescriptionsProps, MenuProps } from 'antd'
import classnames from 'classnames'
import { TableProps } from 'antd/lib/table'

interface IClassNameOptions {
    prefix?: string
}

const ROOT_PREFIX = 'sw'

const parseClassNames = (tokens: string[], opts?: IClassNameOptions): string => {
    const prefix = opts?.prefix

    const swTokens = tokens.map((token) => `${ROOT_PREFIX}-${token}`)
    const prefixedTokens = prefix ? tokens.map((token) => `${ROOT_PREFIX}-${prefix}-${token}`) : []

    return classnames(swTokens, prefixedTokens)
}

interface IAntdClassnameTokens {
    Menu: (opts?: IClassNameOptions) => MenuProps['classNames'] & {
        subMenu: {
            trigger?: string | undefined
        }
    }
    Descriptions: (opts?: IClassNameOptions) => NonNullable<DescriptionsProps['classNames']>
    Table: (opts?: IClassNameOptions) => NonNullable<TableProps['classNames']>
}

export const AntdClassnameTokens: IAntdClassnameTokens = {
    Menu: (opts) => ({
        root: parseClassNames(['menu-root'], opts),
        itemTitle: parseClassNames(['menu-item-title'], opts),
        list: parseClassNames(['menu-list'], opts),
        item: parseClassNames(['menu-item'], opts),
        itemIcon: parseClassNames(['menu-item-icon'], opts),
        itemContent: parseClassNames(['menu-item-content'], opts),
        subMenu: {
            trigger: parseClassNames(['menu-item', 'submenu-trigger'], opts),
            itemTitle: parseClassNames(['submenu-item-title'], opts),
            list: parseClassNames(['submenu-list'], opts),
            item: parseClassNames(['submenu-item'], opts),
            itemIcon: parseClassNames(['submenu-item-icon'], opts),
            itemContent: parseClassNames(['submenu-item-content'], opts),
        },
    }),
    Descriptions: (opts) => ({
        root: parseClassNames(['descriptions-root'], opts),
        header: parseClassNames(['descriptions-header'], opts),
        title: parseClassNames(['descriptions-title'], opts),
        extra: parseClassNames(['descriptions-extra'], opts),
        label: parseClassNames(['descriptions-item-label'], opts),
        content: parseClassNames(['descriptions-item-content'], opts),
    }),
    Table: (opts) => ({
        root: parseClassNames(['table-root'], opts),
        title: parseClassNames(['table-title'], opts),
        section: parseClassNames(['table-section'], opts),
        wrapper: parseClassNames(['table-wrapper'], opts),
        header: {
            wrapper: parseClassNames(['table-header-wrapper'], opts),
            row: parseClassNames(['table-header-row'], opts),
            cell: parseClassNames(['table-header-cell'], opts),
        },
        body: {
            wrapper: parseClassNames(['table-body-wrapper'], opts),
            row: parseClassNames(['table-body-row'], opts),
            cell: parseClassNames(['table-body-cell'], opts),
        },
        footer: parseClassNames(['table-footer'], opts),
        content: parseClassNames(['table-content'], opts),
        cell: parseClassNames(['table-cell'], opts),
        row: parseClassNames(['table-row'], opts),
        column: parseClassNames(['table-column'], opts),
    }),
}
